// removed by extract-text-webpack-plugin
module.exports = {"Page":"_3gFLCifzeIoQ6g6548wBKO"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/index.css
// module id = 841
// module chunks = 0